import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { pillarArticles } from "@/mocks/articles";

export default function PillarGuides() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs md:text-sm font-medium text-accent-800">
            <i className="ri-book-open-line"></i>
            {t("nav.shoppingGuide")}
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
            {t("guides.h2")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("guides.sub")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {pillarArticles.map((a) => (
            <Link
              key={a.slug}
              to={`/${a.slug}`}
              className="group flex flex-col rounded-xl border border-background-200 bg-background-50 overflow-hidden cursor-pointer hover:border-accent-300 transition-colors"
            >
              <div className="relative w-full h-40 md:h-48 overflow-hidden bg-background-100">
                <img
                  src={a.image}
                  alt={t(`pillar.${a.slug}.cardTitle`)}
                  title={`${t(`pillar.${a.slug}.cardTitle`)} — Basetao Sheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 backdrop-blur px-3 py-1 text-xs font-semibold text-foreground-800 whitespace-nowrap">
                  {t(`pillar.${a.slug}.badge`)}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 leading-snug">
                  {t(`pillar.${a.slug}.cardTitle`)}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                  {t(`pillar.${a.slug}.cardDesc`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-accent-700 group-hover:text-accent-800 transition-colors">
                  {t("button.readArticle")}
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}